import { useNavigate, useParams } from 'react-router-dom';
import { useState, Fragment, useContext, useEffect } from 'react';
import { useGet } from '@/query/fetchHooks';
import {
  InputText,
  ContentCard,
  Button,
  IconButton,
  FilterList,
  Card,
  FilterDropdown,
  TEOLoader,
  Tag as ComponentTag,
  FilterButton,
  AvatarStack,
  PersonAvatar,
} from '@teo/components';
import {
  Search,
  Tag,
  ChevronDown,
  ChevronUp,
  ChapterFilled,
  TimeFilled,
  Eye,
} from '@teo/components/icons';
import { useTranslation } from 'react-i18next';
import {
  Membercoursecontentdetails,
  Userwithorganisationwithidps,
} from '@/models';
import { AuthContext } from '@/components/Contexts/AuthContext';
import { PaginationAnything } from '@/components/DataTable/PaginationAnything';
import { newUid, parseQueryString, useMobile, nthLastIndexOf } from '@/util';
import { HintsContext } from '@/components/Contexts/HintsContext';
import { PageUrlContext } from '@/components/Contexts/PageUrlContext';
import { NavContext } from '@/components/NavContext';
import Hint from '@/components/Hints/Hints';
import TypeCourse from '@/components/CreateNewPublication/TypeCourse';
import MobileSubPageMenu from '@/components/HeaderMobile/MobileSubPageMenu';

export interface Filter {
  label: string;
  value: string;
}

const CreateCoursesPage = ({ courseType }: any) => {
  const { t } = useTranslation();
  const isMobile = useMobile();
  const [filter, setFilter] = useState('');
  const [debouncedFilter, setDebouncedFilter] = useState('');
  useEffect(() => {
    const t = setTimeout(() => setDebouncedFilter(filter), 250);
    return () => clearTimeout(t);
  }, [filter]);
  const [filterJoined, setFilterJoined] = useState('');
  const [sort, setSort] = useState([{ id: 'createdAt', desc: true }]);

  const [selected, setSelected] = useState<Filter[]>([]);
  const [filterCourse, setFilterCourse] = useState(false);
  const [moreFilter, setMoreFilter] = useState(false);
  const [loadCourses, setLoadCourses] = useState<any>(true);
  const [coursesType, setCoursesType] = useState<any>();
  const [lpStatusType, setLpStatusType] = useState<any>();
  const [refresh, setRefresh] = useState<string>(newUid(20));
  const [listCategories, setListCategories] = useState<any>([]);
  const [category, setCategory] = useState<any>();

  const [goToCreate, setGoToCreate] = useState(false);
  const [goToCreateLP, setGoToCreateLP] = useState(false);
  const [publicationId, setPublicationId] = useState();
  const [learningpathId, setLearningpathId] = useState();
  const [loadeNewPublication, setLoadeNewPublication] = useState(false);
  const [publicationStatus, setPublicationStatus] = useState<any>(
    'published,OR,publicationStatus=concept,OR,publicationStatus=template,OR,publicationStatus=concept-template,OR,publicationStatus=published-template'
  );
  const [publicationStatusLP, setPublicationStatusLP] = useState<any>(
    'published,OR,lpPublicationStatus=concept'
  );
  // const [selectedStatus, setSelectedStatus] = useState<Filter[]>([
  //   {
  //     label: t('pages.create_courses.active'),
  //     value:
  //       'published,OR,publicationStatus=concept,OR,publicationStatus=template,OR,publicationStatus=concept-template,OR,publicationStatus=published-template',
  //   },
  // ]);

  const [tab, setTab] = useState('active');
  const [tabLP, setTabLP] = useState('active');

  // const [selectedStatusLP, setSelectedStatusLP] = useState<Filter[]>([
  //   {
  //     label: t('pages.create_courses.active'),
  //     value: 'published,OR,lpPublicationStatus=concept',
  //   },
  // ]);

  const [refreshStatus, setRefreshStatus] = useState(newUid(10));
  const [refreshLpStatus, setRefreshLpStatus] = useState(newUid(10));

  const navigate = useNavigate();
  const { organisationId } = useParams();
  const basePath = window.location.pathname;

  const prevPath = window.location.pathname.slice(
    0,
    nthLastIndexOf(window.location.pathname, '/', 1)
  );

  const { newPage } = useContext(PageUrlContext);
  const { hints } = useContext(HintsContext);
  const { auth } = useContext(AuthContext);
  const { setSubPage } = useContext(NavContext);
  const authUser = auth?.user as Userwithorganisationwithidps;

  const [primaryTags, setPrimaryTags] = useState<any>(null);

  const authLang: any = auth?.user.lang;
  const authOrg: any = auth?.user?.activeOrganisationId;

  const queries = parseQueryString(document.location.search) as {
    [key: string]: string;
  };

  const [isOpenTypeModal, setIsOpenTypeModal] = useState(
    !!queries['courseType']
  );

  const [template, setTemplate] = useState('theory');
  const [typeCourse, setTypeCourse] = useState('courses');

  useEffect(() => {
    setSubPage(true);
    return () => setSubPage(false);
  }, []);

  useEffect(() => {
    if (courseType) {
      setLoadCourses(true);
      setFilter('');
      setMoreFilter(false);
      setCoursesType(null);
      setLpStatusType(null);
      setCategory(null);
      setSelected([]);
      setRefresh(newUid(20));
      setTypeCourse(
        courseType == 'assessment'
          ? 'assessments'
          : courseType == 'leervacature'
          ? 'vacancies'
          : courseType == 'instruction'
          ? 'instructions'
          : courseType == 'learning-path'
          ? 'learning-paths'
          : 'courses'
      );
      setPublicationStatusLP('published,OR,lpPublicationStatus=concept');
      setPublicationStatus(
        'published,OR,publicationStatus=concept,OR,publicationStatus=template,OR,publicationStatus=concept-template,OR,publicationStatus=published-template'
      );
      setTab('active');
      setTabLP('active');
    }
  }, [courseType]);

  useEffect(() => {
    if (coursesType?.id) {
      setTab('active');
      if (coursesType?.id === 'template') {
        setPublicationStatus(
          'template,OR,publicationStatus=concept-template,OR,publicationStatus=published-template'
        );
      } else {
        setPublicationStatus(coursesType?.id);
      }
    } else {
      setRefreshStatus(newUid(10));
    }
  }, [coursesType]);

  useEffect(() => {
    if (lpStatusType?.id) {
      // setSelectedStatusLP([]);
      setTabLP('active');
      setPublicationStatusLP(lpStatusType?.id);
    } else {
      setRefreshLpStatus(newUid(10));
    }
  }, [lpStatusType]);

  const selectedTags = selected?.map((el) => el.value + ' ');

  const allCategories: any = useGet(`/categories`, {
    count: 1000,
    sort: 'tag',
    organisationId: `${auth?.user?.activeOrganisationId},OR,organisationId=null`,
    lang: auth?.user?.lang,
  });

  useEffect(() => {
    if (allCategories?.data) {
      const data = (allCategories?.data?.data as any[]).map((tag) => ({
        id: tag?.tag,
        name: tag?.tag,
      }));
      setListCategories(data);
    }
  }, [allCategories?.data]);

  useEffect(() => {
    const newFilterJoined =
      selectedTags.join(' ') +
      (debouncedFilter ? ` ${debouncedFilter}` : '') +
      (category ? `category:${category?.name}` : '');
    setFilterJoined(newFilterJoined);
  }, [debouncedFilter, selectedTags, category]);

  const FILTERS = [
    {
      label: t('pages.create_courses.Electricity'),
      value: t('pages.create_courses.Electricity'),
    },
    {
      label: t('pages.create_courses.Base'),
      value: t('pages.create_courses.Base'),
    },
    {
      label: t('pages.create_courses.Technology'),
      value: t('pages.create_courses.Technology'),
    },
    {
      label: t('pages.create_courses.Safety'),
      value: t('pages.create_courses.Safety'),
    },
    {
      label: t('pages.create_courses.Mechanics'),
      value: t('pages.create_courses.Mechanics'),
    },
  ];

  useGet('/tags', {
    primary: true,
    lang: auth?.user?.lang,
    onSuccess: (result: any) => {
      const tags = result?.data ?? [];
      const pTags = tags?.map((tag: any) => ({
        label: tag?.tag,
        value: tag?.tag,
      }));
      const missingCount = Math.max(0, 5 - pTags?.length);
      setPrimaryTags([...pTags.slice(0, 5), ...FILTERS.slice(0, missingCount)]);
    },
  });

  function convertToTime(number: number) {
    const hours = Math.floor(number / 3600);
    const minutes = Math.round((number / 3600 - hours) * 60);
    return (
      hours +
      `${t('pages.learn_index.hour')} ` +
      minutes +
      `${t('pages.learn_index.minute')} `
    );
  }

  useEffect(() => {
    if (goToCreate) {
      setLoadeNewPublication(false);
      setIsOpenTypeModal(false);
      navigate(`/${authLang}/create/${authOrg}/courses/${publicationId}`);
    }
  }, [goToCreate]);

  useEffect(() => {
    if (goToCreateLP) {
      setLoadeNewPublication(false);
      setIsOpenTypeModal(false);
      navigate(
        `/${authLang}/create/${authOrg}/learning-paths/${learningpathId}`
      );
    }
  }, [goToCreateLP]);

  const createMarkup = (text: any) => {
    if (text) return { __html: text };
  };

  useEffect(() => {
    if (tab) {
      if (tab === 'active') {
        setPublicationStatus(
          'published,OR,publicationStatus=concept,OR,publicationStatus=template,OR,publicationStatus=concept-template,OR,publicationStatus=published-template'
        );
      } else {
        setCoursesType(undefined);
        setPublicationStatus('disabled');
      }
    }
  }, [refreshStatus]);

  useEffect(() => {
    if (tabLP) {
      if (tabLP === 'active') {
        setPublicationStatusLP('published,OR,lpPublicationStatus=concept');
      } else {
        setLpStatusType(undefined);
        setPublicationStatusLP('disabled');
      }
    }
  }, [refreshLpStatus]);

  return !isOpenTypeModal ? (
    <div className="w-full max-w-6xl pb-8">
      {isMobile ? (
        <MobileSubPageMenu
          title={`courseTypes.${courseType}`}
          prevPath={() => navigate(prevPath)}
        />
      ) : (
        <h1 className="my-8 text-xl font-semibold text-black">
          {t(`courseTypes.${courseType}`)}
        </h1>
      )}

      <Fragment>
        <div
          className={`relative mb-8 sm:w-2/3 md:w-1/2 ${
            hints?.id == `hint_28` && 'active-hint-parent !z-[100]'
          }`}
        >
          <Hint
            key={`hint_28_${newPage}`}
            id={`hint_28`}
            leftDots={'-left-2 top-2'}
            title={t(`hint.title_28`)}
            order={28}
            style={{
              left: '-10px',
              top: '60px',
            }}
          />
          <InputText
            value={filter}
            onChange={(ev) => setFilter(ev.target.value)}
            Icon={Search}
            placeholder={t('search.course')}
          />
        </div>
        <div className="mb-8 flex flex-col justify-between gap-4 lg:flex-row lg:gap-0">
          <div
            className={`relative flex items-center ${
              hints?.id == `hint_29` && 'active-hint-parent !z-[100]'
            }`}
          >
            <Hint
              key={`hint_29_${newPage}`}
              id={`hint_29`}
              leftDots={'-left-2 top-[3px]'}
              title={t(`hint.title_29`)}
              order={29}
              style={{
                left: '-10px',
                top: '60px',
              }}
            />
            <IconButton Icon={Tag} variant="ghost" size="sm" className="mr-2" />
            {primaryTags && (
              <FilterList
                filters={primaryTags}
                onSelect={setSelected}
                selected={selected}
              />
            )}
          </div>
          <div className="flex items-center">
            <Button
              variant="outline"
              size="sm"
              className="ml-auto mr-2"
              onClick={() => {
                setMoreFilter(!moreFilter);
              }}
            >
              {moreFilter
                ? t('pages.create_edit_course.library.fewer_filters')
                : t('pages.create_edit_course.library.more_filters')}
            </Button>
            <Button
              className="flex items-center"
              variant="ghost"
              size="sm"
              onClick={() =>
                sort[0].desc
                  ? setSort([{ id: 'createdAt', desc: false }])
                  : setSort([{ id: 'createdAt', desc: true }])
              }
            >
              <div className="pr-2">{t('pages.create_courses.latest')}</div>
              {sort[0].desc ? (
                <ChevronUp className="w-5" />
              ) : (
                <ChevronDown className="w-5" />
              )}
            </Button>
          </div>
        </div>
        {moreFilter && (
          <div className="relative z-10 mt-5 flex flex-col">
            <div className="mb-4 flex flex-col sm:flex-row">
              <div className="mr-2">
                {courseType === 'learning-path' ? (
                  <div className={`relative flex flex-wrap items-center gap-2`}>
                    <FilterButton
                      active={tabLP === 'active'}
                      onClick={() => {
                        if (tabLP != 'active') {
                          setTabLP('active');
                          setRefreshLpStatus(newUid(10));
                        }
                      }}
                    >
                      <p className="flex items-center gap-1">
                        {t('pages.create_courses.active')}
                      </p>
                    </FilterButton>
                    <FilterButton
                      active={tabLP === 'inactive'}
                      onClick={() => {
                        if (tabLP != 'inactive') {
                          setTabLP('inactive');
                          setRefreshLpStatus(newUid(10));
                        }
                      }}
                    >
                      <p className="flex items-center gap-1">
                        {t('pages.create_courses.inactive')}
                      </p>
                    </FilterButton>
                  </div>
                ) : (
                  <div className={`relative flex flex-wrap items-center gap-2`}>
                    <FilterButton
                      active={tab === 'active'}
                      onClick={() => {
                        if (tab != 'active') {
                          setTab('active');
                          setRefreshStatus(newUid(10));
                        }
                      }}
                    >
                      <p className="flex items-center gap-1">
                        {t('pages.create_courses.active')}
                      </p>
                    </FilterButton>
                    <FilterButton
                      active={tab === 'inactive'}
                      onClick={() => {
                        if (tab != 'inactive') {
                          setTab('inactive');
                          setRefreshStatus(newUid(10));
                        }
                      }}
                    >
                      <p className="flex items-center gap-1">
                        {t('pages.create_courses.inactive')}
                      </p>
                    </FilterButton>
                  </div>
                )}
              </div>
              <span className="mb-4 pr-2 sm:mb-0">
                <FilterDropdown
                  key={refresh}
                  clearButtonLabel="clear"
                  onChange={(value: any) => {
                    setLoadCourses(true);
                    setRefresh(newUid(20));
                    setCategory(value);
                  }}
                  buttonText={`${t('pages.create_library.category')}`}
                  options={listCategories}
                  searchable={true}
                  value={category}
                />
              </span>
              {courseType !== 'instruction' &&
                courseType !== 'learning-path' && (
                  <span className="pr-2">
                    <FilterDropdown
                      clearButtonLabel="clear"
                      onChange={(value: any) => {
                        setLoadCourses(true);
                        setRefresh(newUid(20));
                        setCoursesType(value);
                      }}
                      buttonText={`${t('columns.status')}`}
                      options={[
                        {
                          id: 'published',
                          name: 'published',
                        },
                        {
                          id: 'concept',
                          name: 'concept',
                        },
                        {
                          id: 'template',
                          name: 'template',
                        },
                      ]}
                      // searchable={true}
                      value={coursesType}
                      dropdownPositionMobileRight={true}
                    />
                  </span>
                )}
              {courseType === 'learning-path' && (
                <span className="pr-2">
                  <FilterDropdown
                    clearButtonLabel="clear"
                    onChange={(value: any) => {
                      setLoadCourses(true);
                      setRefresh(newUid(20));
                      setLpStatusType(value);
                    }}
                    buttonText={`${t('columns.status')}`}
                    options={[
                      {
                        id: 'published',
                        name: 'published',
                      },
                      {
                        id: 'concept',
                        name: 'concept',
                      },
                    ]}
                    value={lpStatusType}
                    dropdownPositionMobileRight={true}
                  />
                </span>
              )}
            </div>
          </div>
        )}
        {loadCourses && (
          <div className="mx-auto flex justify-center py-20 px-10">
            <TEOLoader
              loaderSrc="/images/TEOloader.gif"
              className="w-[100px]"
            />
          </div>
        )}
        <div className={`w-full ${loadCourses === true && ' hidden '}`}>
          <PaginationAnything
            key={refresh}
            className={`mt-3 grid w-full grid-cols-2 gap-x-4 gap-y-8 sm:grid-cols-3 lg:grid-cols-4 ${
              loadCourses === true && ' hidden '
            }`}
            fetch={
              courseType === 'learning-path'
                ? useGet.bind(null, '/mylps', {
                    organisationId: authUser?.activeOrganisationId,
                    userId: authUser?.id,
                    lpIsRoot: true,
                    masterId: 'null',
                    lpPublicationStatus: publicationStatusLP,
                    onSuccess: (result: any) => {
                      setLoadCourses(false);
                    },
                  })
                : useGet.bind(null, '/myowedpublications', {
                    //minrole: 50,
                    publicationCourseType: courseType,
                    organisationId: authUser?.activeOrganisationId,
                    userId: authUser?.id,
                    publicationStatus: publicationStatus,
                    // template: coursesType?.id,
                    onSuccess: (result: any) => {
                      setLoadCourses(false);
                    },
                  })
            }
            empty={
              publicationStatus === 'disabled'
                ? {
                    template: 2,
                    loadContent: loadCourses,
                    text:
                      courseType === 'learning-path'
                        ? t('empty_tenplate.lp_list')
                        : t('empty_tenplate.course_list'),
                  }
                : {
                    template: 2,
                    loadContent: loadCourses,
                    text:
                      courseType === 'learning-path'
                        ? t('empty_tenplate.lp_list')
                        : t('empty_tenplate.course_list'),
                    btn_text:
                      courseType === 'learning-path'
                        ? t('empty_tenplate.btn_creat_lp')
                        : t('empty_tenplate.btn_creat_course'),
                    btnClick: () => setIsOpenTypeModal(true),
                  }
            }
            filter={filterJoined}
            pageSize={12}
            defaultSort={courseType === 'learning-path' ? sort : sort}
            render={(course: any) => (
              <div className="relative" key={course.id}>
                {courseType !== 'learning-path' ? (
                  <Card className="group max-w-[264px]">
                    <button
                      onClick={() =>
                        navigate(`${basePath}/${course.coursecontentId}`)
                      }
                      className="mb-1 flex flex-col text-left"
                    >
                      <div className="relative mb-2 overflow-hidden rounded-lg ">
                        <img
                          src={
                            course?.image && !course?.image.indexOf('http')
                              ? course.image
                              : '/assets/images/opleidingen.jpg'
                          }
                          alt={course?.name}
                          className="h-[140px] w-[264px] rounded-lg object-cover object-center transition-transform duration-500 group-hover:scale-105"
                        />
                        <div className="absolute inset-0 h-full w-full rounded-lg group-hover:backdrop-blur-sm"></div>
                        <span className="absolute inset-0 hidden items-center justify-center group-hover:flex">
                          <span className="rounded-md bg-grey-01 p-1 text-grey-09">
                            <Eye className="h-5 w-5 "></Eye>
                          </span>
                        </span>
                      </div>

                      <div className="mb-2.5 text-left">
                        <ComponentTag
                          title={course.publicationStatus || ''}
                          variant={
                            course.publicationStatus === 'published' ||
                            course.publicationStatus === 'published-template'
                              ? 'primary'
                              : 'default'
                          }
                        />
                      </div>
                      <Card.Title bottomMargin="sm">
                        <span className="break-keep">
                          {course?.name ? course?.name : ''}
                        </span>
                      </Card.Title>
                      {course?.description ? (
                        <div>
                          <div
                            className="wrap-break-word mb-2.5 max-h-[60px] max-w-[264px] overflow-hidden text-ellipsis break-normal text-left text-sm font-normal text-[#6d6d72]"
                            dangerouslySetInnerHTML={createMarkup(
                              course?.description || ''
                            )}
                          />
                        </div>
                      ) : null}
                    </button>
                    <div className="flex h-9 items-center gap-3 group-hover:hidden">
                      {course.authorId && (
                        <PersonAvatar
                          name={course?.username}
                          id={course.authorId}
                          imageSrc={course.picture}
                        />
                      )}
                      {course?.nrOfLessons ? (
                        <span className="align-middle text-sm text-grey-04">
                          <ChapterFilled className="inline h-5 w-5" />{' '}
                          {course?.nrOfLessons ? course?.nrOfLessons : 0}
                        </span>
                      ) : null}
                      {course?.totalEstimatedTime ? (
                        <span className="align-middle text-sm text-grey-04">
                          <TimeFilled className="inline h-5 w-5" />{' '}
                          {course?.totalEstimatedTime
                            ? convertToTime(
                                Math.abs(course?.totalEstimatedTime)
                              )
                            : ''}
                        </span>
                      ) : null}
                    </div>
                    <div className="hidden h-9 items-center gap-2 group-hover:flex">
                      {course.authorId && (
                        <PersonAvatar
                          name={course?.username}
                          id={course.authorId}
                          imageSrc={course.picture}
                        />
                      )}
                      <Card.Button
                        onClick={() =>
                          navigate(`${basePath}/${course.coursecontentId}`)
                        }
                      >
                        {t('pages.create_index.to_process')}
                      </Card.Button>
                      <div className="absolute top-0">
                        <img
                          key={course.id}
                          src={`/images/lang_flags/${course.lang}_lang.png`}
                          alt="courseImage"
                          className="
                          mt-2
                          ml-2
                          h-[25px]
                          w-[25px] rounded-[50%]
                          bg-tint-red
                          object-cover
                          "
                        />
                      </div>
                    </div>
                  </Card>
                ) : (
                  <Card className="group max-w-[264px]">
                    <button
                      onClick={() => navigate(`${basePath}/${course.id}`)}
                      className="mb-1 flex flex-col text-left"
                    >
                      <div className="relative mb-2 overflow-hidden rounded-lg ">
                        <img
                          src={
                            course?.lpPicture &&
                            !course?.lpPicture.indexOf('http')
                              ? course.lpPicture
                              : '/assets/images/LearnPath.png'
                          }
                          alt={course?.lpName}
                          className="h-[140px] w-[264px] rounded-lg object-cover object-center transition-transform duration-500 group-hover:scale-105"
                        />
                        <div className="absolute inset-0 h-full w-full rounded-lg group-hover:backdrop-blur-sm"></div>
                        <span className="absolute inset-0 hidden items-center justify-center group-hover:flex">
                          <span className="rounded-md bg-grey-01 p-1 text-grey-09">
                            <Eye className="h-5 w-5 "></Eye>
                          </span>
                        </span>
                      </div>
                      <div className="mb-2.5 text-left">
                        <ComponentTag
                          title={course?.lpPublicationStatus || ''}
                          variant={
                            course.lpPublicationStatus === 'published'
                              ? 'primary'
                              : 'default'
                          }
                        />
                      </div>
                      <Card.Title bottomMargin="sm">
                        <span className="break-keep">
                          {course?.lpName ? course?.lpName : ''}
                        </span>
                      </Card.Title>
                      {course?.lpDescription ? (
                        <div
                          className="wrap-break-word mb-2.5 max-h-[60px] max-w-[264px] overflow-hidden text-ellipsis break-normal text-left text-sm font-normal text-[#6d6d72]"
                          dangerouslySetInnerHTML={createMarkup(
                            course?.lpDescription || ''
                          )}
                        />
                      ) : null}
                    </button>
                    <div className="flex h-9 items-center gap-3 group-hover:hidden">
                      <span className="align-middle text-sm text-grey-04">
                        <ChapterFilled className="inline h-5 w-5" />{' '}
                        {course?.nrOfNodes ? course?.nrOfNodes : 0}
                      </span>
                    </div>
                    <div className="hidden h-9 gap-2 group-hover:flex">
                      <>
                        <Card.Button
                          onClick={() => navigate(`${basePath}/${course.id}`)}
                        >
                          {t('pages.create_index.to_process')}
                        </Card.Button>
                        <div className="absolute top-0">
                          <img
                            key={course.id}
                            src={`/images/lang_flags/${
                              course.lang ? course.lang : 'en'
                            }_lang.png`}
                            alt="courseImage"
                            className="
                          mt-2
                          ml-2
                          h-[25px]
                          w-[25px] rounded-[50%]
                          bg-tint-red
                          "
                          />
                        </div>
                      </>
                    </div>
                  </Card>
                )}
              </div>
            )}
          />
        </div>
      </Fragment>
    </div>
  ) : (
    <>
      <TypeCourse
        setIsOpenTypeModal={setIsOpenTypeModal}
        setTemplate={setTemplate}
        template={template}
        setGoToCreate={setGoToCreate}
        setGoToCreateLP={setGoToCreateLP}
        typeCourse={typeCourse}
        setPublicationId={setPublicationId}
        setLearningpathId={setLearningpathId}
        publicationId={publicationId}
        setLoadeNewPublication={setLoadeNewPublication}
      />
      {loadeNewPublication && (
        <div className="fixed inset-0 z-[201] m-auto flex min-h-screen min-w-full bg-white/75 p-10">
          <div className="m-auto">
            <TEOLoader
              loaderSrc="/images/TEOloader.gif"
              className="w-[100px]"
            />
          </div>
        </div>
      )}
    </>
  );
};

export default CreateCoursesPage;
